/**
 * FrontierBackdrop — the platform-wide ambient skin for Frontier mode.
 *
 * This is what makes "flip to Frontier" change EVERY page, not just the seven
 * surfaces that mount a <FrontierLead>. It renders a fixed, behind-everything
 * deep-space + cyan/teal aura that tints the whole app the moment the toggle
 * flips. Forms, grids, settings, Communications, Projects — all of it sits on
 * the Frontier substrate, so the posture is unmistakable everywhere.
 *
 * It is purely decorative (pointer-events-none, aria-hidden) and is tuned to
 * read on BOTH light and dark themes — the auras are low-opacity so they tint
 * rather than wash out content (see feedback_contrast_both_modes_standard).
 *
 * Mounted once at the AppShell root, gated on useUiMode === "frontier".
 */

export function FrontierBackdrop() {
  return (
    <div
      aria-hidden
      data-testid="frontier-backdrop"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-[var(--color-surface-secondary)]"
    >
      {/* Deep-space base wash — barely-there in light, richer in dark. */}
      <div className="absolute inset-0 bg-[radial-gradient(120%_120%_at_50%_-10%,rgba(20,184,166,0.06),transparent_55%)] dark:bg-[radial-gradient(120%_120%_at_50%_-10%,rgba(13,148,136,0.16),transparent_60%)]" />
      {/* Top-right cyan aura. */}
      <div className="absolute -right-32 -top-24 h-[36rem] w-[36rem] rounded-full bg-cyan-400/10 blur-3xl dark:bg-cyan-500/15" />
      {/* Bottom-left teal aura — anchors the gradient diagonal. */}
      <div className="absolute -bottom-40 -left-24 h-[40rem] w-[40rem] rounded-full bg-teal-400/10 blur-3xl dark:bg-teal-500/12" />
      {/* Faint horizon line near the top — the "deep space" signature. */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />
    </div>
  );
}
